/**
 * Represents the TrucksAvailable component, which displays available trucks and related information.
 *
 * @component
 * @returns {React.ReactElement} The TrucksAvailable component.
 */
import React, { useState, useEffect, useContext } from "react";
import Axios from "../../Axios";
import { Urls } from "../../Urls";
import classes from "./TrucksAvailable.module.css";
import PopupModal from "../Shared/PopupModal/PopupModal";
import Loader from "../Loader";
import Sendenquirynew from "../TransporterClientScreen/TransporterDetailsBody/Profile/Sendenquirynew";
import { useHistory } from "react-router";
import "./TrucksAvailable.css";
import { DateFormatter2, isMobile } from "../../Constants";
import ProfileModal from "../TransporterClientScreen/ProfileModal/ProfileModal";
import ReactGA from "react-ga4";
import { useMixPanelForTracking } from "../../utils/TrackMixPanel";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";
import useViewOnlyAccess from "../../hooks/useViewOnlyAccess";

const TrucksAvailable = () => {
  const { isRestricted, checkActionPermission } = useViewOnlyAccess("spot");
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const history = useHistory();
  const [show, setshow] = useState(false);
  const [details, setdetails] = useState([]);
  const [filtered_details, setfiltered_details] = useState([]);
  const [refresh, setrefresh] = useState(false);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  /**
   * Fetches data from the server and updates the state with the truck details.
   * Also tracks the page view using Google Analytics.
   *
   * @function
   * @returns {void}
   */
  useEffect(() => {
    ReactGA.send("LoRRI Spot - Transporter Enquiries");
    document.title = "LoRRI Spot - Transporter Enquiries";
    setshow(true);
    Axios.get(Urls.streamingData)
      .then((res) => {
        setdetails(res.data.streaming_data_by_transporters);
        setfiltered_details(res.data.streaming_data_by_transporters);
        setshow(false);
      })
      .catch((err) => {
        console.log(err);
        setshow(false);
      });

    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "transporter enquiries",
      Data: `None`,
      Definition: "user has clicked on transporter enquiries",
    });
  }, []);
  const Enquiry = (data) => {
    Axios.get(Urls.inmail)
      .then((res) => {
        var stream_data = data;
        var enquiry_data = res.data.enquiries;
        var data_list = [];
        var all_subject_list = [];
        var all_lsp_list = [];
        if (enquiry_data && enquiry_data.length > 0) {
          enquiry_data.map((item) => {
            var lsp_list = [];
            item.users.transporter.map((lsp) => {
              lsp_list.push(lsp.transporter_id);
            });
            data_list.push({ subject: item.subject, lsps: lsp_list });
          });
        }
        if (data_list && data_list.length > 0) {
          data_list.map((item) => {
            all_subject_list.push(item.subject);
          });
        }
        if (enquiry_data && enquiry_data.length > 0) {
          enquiry_data.map((item) => {
            item.users.transporter.map((lsp) => {
              all_lsp_list.push(lsp.transporter_id);
            });
          });
        }
        var updated_stream = stream_data.map((item) => {
          data_list.map((data) => {
            if (
              data.subject.includes(
                `Enquiry for ${item.origin.location.location} TO ${item.destination.length > 0
                  ? item.destination.map((data) =>
                    data.location ? data.location.location : null
                  )
                  : "Not Specified"
                }`
              ) &&
              data.lsps.includes(item.transporter_id)
            ) {
              item.isMessaged = true;
            }
          });
          return item;
        });
        setdetails(updated_stream);
        setfiltered_details(updated_stream);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  /**
   * Handles filtering of truck details based on user input.
   *
   * @param {Object} event - The event object from the input change.
   * @returns {void}
   */
  const handleInput = (event) => {
    const input = event.target.value.toLowerCase().trim();

    if (!input) {
      setfiltered_details(details);
      return;
    }

    const filtered = details.filter((detail) => {
      const originMatch = detail.origin?.location_name
        ?.toLowerCase()
        .includes(input);
      const transporterMatch = detail.transporter_name
        ?.toLowerCase()
        .includes(input);

      const destinationMatch = detail.destination?.some((dest) =>
        dest.location_name?.toLowerCase().includes(input)
      );

      const truckTypeMatch = detail.truck_type?.some((truck) =>
        truck.label?.toLowerCase().includes(input)
      );

      return (
        originMatch || transporterMatch || destinationMatch || truckTypeMatch
      );
    });

    setfiltered_details(filtered);
  };

  /**
   * Handles redirection to the 'Lorri InMail' page.
   *
   * @param {Object} e - The event object from the button click.
   * @returns {void}
   */
  const messagedClick = (e) => {
    history.push({ pathname: "/LorriInMail" });
  };

  /**
   * Refreshes the enquiry data when the 'refresh' state changes.
   *
   * @function
   * @returns {void}
   */
  useEffect(() => {
    if (refresh) {
      Enquiry(details);
      setrefresh(false);
    }
  }, [refresh]);

  return (
    <div className="w-100">
      <Loader show={show} />

      <div className="row" style={{ marginTop: "2%" }}>
        <input
          className={`${classes["s-filterr"]}`}
          placeholder={
            isMobile()
              ? "Filter by origin, destination, transporter name"
              : "Filter the results by entering Origin, Destination,Transporter Name"
          }
          onChange={handleInput}
        />
      </div>

      <div className={classes["t-divv"]}>
        {isMobile() ? (
          <div>
            {filtered_details && filtered_details.length > 0 ? (
              filtered_details.map((item, index) => (
                <div
                  className={classes["mobile-transporter-enquiry"]}
                  key={item.timestamp}
                >
                  <div
                    className={`${classes["mobile-transporter-enquiry-index"]}`}
                  >
                    {index + 1}
                  </div>
                  <div
                    className={`${classes["mobile-transporter-enquiry-timestamp"]}`}
                  >
                    {item.timestamp ? DateFormatter2(item.timestamp) : "NA"}
                  </div>
                  <div
                    className={`${classes["mobile-transporter-enquiry-origin"]}`}
                  >
                    <b>Origin:</b>
                    {item.origin && item.origin.location_name
                      ? item.origin.location_name
                      : "NA"}
                  </div>
                  <div
                    className={`${classes["mobile-transporter-enquiry-destination"]}`}
                  >
                    <b>Destination</b>
                    <br />
                    {item.destination
                      ? item.destination.map((location, no) => (
                        <>
                          <span>
                            {no + 1}. {location.location_name}
                          </span>
                          <br />
                        </>
                      ))
                      : "NA"}
                  </div>
                  <div
                    className={`${classes["mobile-transporter-enquiry-trucks"]}`}
                  >
                    <b>Truck Types:</b>
                    <br />
                    {item.truck_type
                      ? item.truck_type.map((truck, number) => (
                        <>
                          <span>
                            {number + 1}. {truck.label}
                          </span>
                          <br />
                        </>
                      ))
                      : "NA"}
                  </div>
                  <div
                    className={`${classes["mobile-transporter-enquiry-notrucks"]}`}
                  >
                    <b># Trucks: </b>{" "}
                    {item.available_trucks ? item.available_trucks : "NA"}
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <b>Transporter Name:</b>
                    <ProfileModal
                      transporter_id={item.transporter_id}
                      transporter_name={item.transporter_name}
                      screenName="LoRRI Adhoc Dashboard"
                      moduleName="LoRRI Adhoc"
                      buttonClass={`btn-link ${classes["mobile-transporter-name"]}`}
                    />
                  </div>
                  <div>
                    {item.isMessaged ? (
                      <button
                        style={{
                          width: "88%",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                        onClick={(e) => messagedClick(e)}
                        className="btn btn-sm"
                      >
                        Messaged
                      </button>
                    ) : (
                      <div

                        style={{ display: 'inline-block', cursor: isRestricted ? 'not-allowed' : 'pointer', width: '100%' }}
                      >
                        <PopupModal
                          id="Enquiry"
                          content={
                            <Sendenquirynew
                              refresh={setrefresh}
                              transporter={item}
                            />
                          }
                          buttonLabel="Send Message"
                          className="ProcurementModal"
                          title="Enquiry"
                          buttonClass="btn btn-sm btn-success"
                          screenName="Trucks Available"
                          moduleName="Transporter Enquiries"
                          activityName={`Send message button clicked for ${item.origin.location_name} to ${item.destination.location_name}`}
                          disabled={isRestricted}
                          style={{ pointerEvents: isRestricted ? 'none' : 'auto', width: '100%' }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div>
                <div
                  colSpan="8"
                  style={{
                    padding: "5% 0",
                    fontSize: "large",
                    fontStyle: "italic",
                  }}
                >
                  No enquiries to display
                </div>
              </div>
            )}
          </div>
        ) : (
          <table className={classes["table-s"]}>
            <thead
              style={{
                textAlign: "center",
                backgroundColor: "#f2f2f2",
                lineHeight: "13px",
              }}
            >
              <tr>
                <th style={{ width: "2%" }}>Sr.No</th>
                <th style={{ width: "12%", textAlign: "center" }}>
                  Date of Enquiry
                </th>
                <th style={{ width: "20%", textAlign: "center" }}>
                  Origin Location
                </th>
                <th style={{ width: "20%", textAlign: "center" }}>
                  Preferred Destination Location
                </th>
                <th style={{ width: "10%", textAlign: "center" }}>
                  Truck Type
                </th>
                <th style={{ width: "6%", textAlign: "center" }}>
                  # Trucks Available
                </th>
                <th style={{ width: "20%", textAlign: "center" }}>
                  Transporter Name
                </th>
                <th style={{ width: "10%", textAlign: "center" }}>
                  Send Logistics Enquiry
                </th>
              </tr>
            </thead>
            <tbody>
              {filtered_details && filtered_details.length > 0 ? (
                filtered_details.map((item, index) => (
                  <tr
                    style={{ borderBottom: "1px solid lightgrey" }}
                    key={item.timestamp}
                  >
                    <td className={`${classes["s-pthead"]}`}>{index + 1}</td>
                    <td>
                      {item.timestamp ? DateFormatter2(item.timestamp) : "NA"}
                    </td>
                    <td>
                      {item.origin && item.origin.location_name
                        ? item.origin.location_name
                        : "NA"}
                    </td>
                    <td>
                      {item.destination
                        ? item.destination.map((location, no) => (
                          <>
                            <span>{location.location_name}</span>
                            <br />
                          </>
                        ))
                        : "NA"}
                    </td>
                    <td>
                      {item.truck_type
                        ? item.truck_type.map((truck, number) => (
                          <>
                            <span>{truck.label}</span>
                            <br />
                          </>
                        ))
                        : "NA"}
                    </td>
                    <td className={`${classes["s-pthead"]}`}>
                      {item.available_trucks ? item.available_trucks : "NA"}
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <ProfileModal
                        transporter_id={item.transporter_id}
                        transporter_name={item.transporter_name}
                        screenName="LoRRI Adhoc Dashboard"
                        moduleName="LoRRI Adhoc"
                      />
                    </td>
                    <td>
                      {item.isMessaged ? (
                        <button
                          style={{
                            width: "88%",
                            backgroundColor: "gray",
                            color: "white",
                          }}
                          onClick={(e) => messagedClick(e)}
                          className="btn btn-sm"
                        >
                          Messaged
                        </button>
                      ) : (
                        <div

                          style={{ display: 'inline-block', cursor: isRestricted ? 'not-allowed' : 'pointer' }}
                        >
                          <PopupModal
                            id="Enquiry"
                            backdrop="true"
                            content={
                              <Sendenquirynew
                                refresh={setrefresh}
                                transporter={item}
                              />
                            }
                            buttonLabel="Send Message"
                            className="ProcurementModal"
                            title="Enquiry"
                            buttonClass="btn btn-sm btn-success"
                            screenName="Trucks Available"
                            moduleName="Transporter Enquiries"
                            activityName={`Send message button clicked for ${item.origin.location_name} to ${item.destination.location_name}`}
                            disabled={isRestricted}
                            style={{ pointerEvents: isRestricted ? 'none' : 'auto' }}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="8"
                    style={{
                      padding: "5% 0",
                      fontSize: "large",
                      fontStyle: "italic",
                    }}
                  >
                    No enquiries to display
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default TrucksAvailable;
